import {SearchFormPresenter} from "@modules/onBoarding/application/port/output/SearchFormPresenter";
import {SearchFormViewModel} from "@modules/onBoarding/presentation/viewModel/SearchFormViewModel";

export class SearchFormViewModelPresenter implements SearchFormPresenter<SearchFormViewModel> {
    displayForm(): SearchFormViewModel {
        return {
            title: "Search your company",
            vatNumber: {
                label: "Enter VAT Number",
                placeholder: "Ex: BE2344455",
            },
            separatorLabel: 'And/Or',
            companyName: {
                label: "Enter Company name",
                placeholder: "Optional if you have a VAT number",
            },
            submitLabel: "Find my company"
        };
    }
}
